import { isEmpty } from 'lodash';

import { Breeder } from 'dogpark/types';

export const isBreederActive = (breeder: Breeder): boolean => {
  const { users } = breeder;

  if (isEmpty(users)) return false;

  return Boolean(users[0].isActive && users[0].pivot.isPrimary);
};
